type Props = {
  children: React.ReactElement;
};

const DefaultLayout: React.FC<Props> = ({ children }) => {
  return children;
};

export default DefaultLayout;
